export const SITE = {
  name: 'CapableBee',
  description:
    'CapableBee is an AI voice assistant that handles your business calls 24/7, capturing leads, booking appointments, and gathering customer feedback automatically, so you never miss an opportunity.',
  email: 'support@capablebee.com',
  phone: '+1-934-252-6170',
  loginUrl: 'https://dashboard.capablebee.com/',
  downloads: {
    windows: 'https://capablebee.com/download/windows.exe',
    macos: 'https://capablebee.com/download/macos',
  },
};

export const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Products', to: '/products' },
  { label: 'Contact Us', to: '/contact' },
];

export const RESOURCE_LINKS = [
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms of Use', to: '/terms-of-service' },
  { label: 'Refund Policy', to: '/refund-policy' },
  { label: 'Cookie Policy', to: '/cookie-policy' },
  { label: 'FAQ', to: '/faq' },
];

export const FEATURES = [
  {
    id: 'call-handling',
    title: 'Instant Call Handling',
    description:
      'Respond to every caller instantly. AI handles multiple calls at once without wait times or missed opportunities.',
  },
  {
    id: 'scalable',
    title: 'Scalable for Any Business',
    description: 'CapableBee grows with your business and manages conversations effortlessly.',
  },
  {
    id: 'human-voice',
    title: 'Human-Like Voice',
    description: "Your customers won't even realize they're talking to AI.",
  },
  {
    id: 'dashboard',
    title: 'Custom Dashboard',
    description: 'Customize the dashboard display according to your needs.',
  },
  {
    id: 'follow-ups',
    title: 'Automated Follow-Ups',
    description:
      'Stay connected with every lead. Automatically send follow-ups through email, SMS, or calls after every conversation.',
  },
];

export const PRICING = [
  {
    id: 'starter',
    name: 'Starter Plan',
    price: 199,
    blurb: 'For small businesses getting started with AI voice.',
    featured: false,
    features: [
      '1 Team Members',
      '24/7 call handling',
      'Basic lead capture',
      'Advanced analytics',
      'Premium support',
      'Advanced security',
    ],
  },
  {
    id: 'professional',
    name: 'Professional Plan',
    price: 349,
    blurb: 'For growing businesses that need more power and flexibility.',
    featured: true,
    features: [
      '3 Team Members',
      '10 GB Cloud Storage',
      'Email lead notifications',
      'Advanced analytics',
      'Premium support',
      'Advanced security',
    ],
  },
  {
    id: 'enterprise',
    name: 'Enterprise Plan',
    price: 549,
    blurb: 'For large businesses with high call volumes.',
    featured: false,
    features: [
      '10 Team Members',
      'CRM integration',
      'Dedicated infrastructure',
      'Advanced analytics',
      'Premium support',
      'Advanced security',
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: 'Rohan Mehra',
    role: 'Product Manager',
    avatar: '/brand/avatar-rohan.jpg',
    quote:
      'CapableBee has completely changed how we handle incoming calls. The AI sounds incredibly natural and captures leads even when our team is offline.',
  },
  {
    name: 'David Ramirez',
    role: 'Founder of NextFlow',
    avatar: '/brand/avatar-david.jpg',
    quote:
      "I was surprised by how human the voice sounds. It answers client questions and collects contact details perfectly. It's like having an assistant working 24/7.",
  },
  {
    name: 'Sophia Lee',
    role: 'Marketing Director',
    avatar: '/brand/avatar-sophia.jpg',
    quote:
      'Before CapableBee we missed many potential customers. Now every call is answered instantly and new leads are automatically captured.',
  },
];

export const FAQS = [
  {
    q: 'What is CapableBee?',
    a: 'CapableBee is an AI-powered voice assistant platform that helps businesses automate phone conversations, capture leads, and handle customer inquiries 24/7 without human intervention.',
  },
  {
    q: 'How does the AI voice assistant work?',
    a: 'Our AI voice assistant answers incoming calls, understands customer questions, and responds naturally using advanced speech and language technology. It can also collect customer details and generate leads automatically.',
  },
  {
    q: 'Can the AI sound like a real human?',
    a: 'Yes. CapableBee uses advanced AI voice technology to create natural, human-like conversations that feel smooth and realistic for callers.',
  },
  {
    q: 'Can the AI capture customer leads?',
    a: 'Absolutely. The AI assistant can collect important information such as name, phone number, email, and inquiry details, helping you generate qualified leads from every call.',
  },
  {
    q: 'Is CapableBee available 24/7?',
    a: 'Yes. Your AI assistant works around the clock, answering calls and assisting customers anytime without breaks.',
  },
  {
    q: 'Can CapableBee integrate with my CRM?',
    a: 'Yes. CapableBee can integrate with various CRM systems and APIs, allowing you to automatically store leads, track conversations, and manage customer interactions.',
  },
  {
    q: 'How long does it take to set up?',
    a: 'Setup is quick and simple. Our team can configure your AI assistant and customize it for your business needs within a short time.',
  },
  {
    q: 'Do I need technical knowledge to use CapableBee?',
    a: 'No. CapableBee is designed to be simple and user-friendly. Our team handles the setup and provides support so you can focus on growing your business.',
  },
];

export const LEGAL_PATHS = {
  privacy: '/privacy-policy',
  terms: '/terms-of-service',
  refund: '/refund-policy',
  cookie: '/cookie-policy',
};
